import './UnderlineTabbedInterface-20c3ba3d.css';

var classes = {"UnderlineWrapper":"prc-components-UnderlineWrapper-oOh5J","UnderlineItemList":"prc-components-UnderlineItemList-b23Hf","UnderlineItem":"prc-components-UnderlineItem-lJsg-","LoadingCounter":"prc-components-LoadingCounter-Ps-0Q"};

export { classes as default };
